import { render, staticRenderFns } from "./CurrenciesTable.vue?vue&type=template&id=343392d4"
import script from "./CurrenciesTable.vue?vue&type=script&lang=js"
export * from "./CurrenciesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports